/**
 * Eagle PDP module — gallery, variants, accordions, sticky bar,
 * async recommendations, recently viewed. Vanilla JS, no dependencies.
 */
(function () {
  var root = document.querySelector('[data-pdp]');
  if (!root) return;

  var moneyFormat = root.dataset.moneyFormat || '${{amount}}';
  function money(cents) {
    var amount = (cents / 100).toFixed(2);
    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','));
  }

  /* ---------- gallery ---------- */
  var track = root.querySelector('[data-track]');
  var slides = Array.prototype.slice.call(root.querySelectorAll('[data-slide]'));
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));
  var dotsWrap = root.querySelector('[data-dots]');
  var current = 0;

  function goTo(index, smooth) {
    if (!slides[index]) return;
    current = index;
    slides.forEach(function (s, i) {
      s.setAttribute('aria-hidden', i === index ? 'false' : 'true');
    });
    if (track) {
      track.scrollTo({ left: slides[index].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
    }
    thumbs.forEach(function (t, i) {
      if (i === index) t.setAttribute('aria-current', 'true');
      else t.removeAttribute('aria-current');
    });
    updateDots();
  }

  thumbs.forEach(function (t) {
    t.addEventListener('click', function () {
      goTo(parseInt(t.dataset.index, 10));
    });
  });

  // mobile dots
  function updateDots() {
    if (!dotsWrap) return;
    var dots = dotsWrap.querySelectorAll('.pdp__dot');
    dots.forEach(function (d, i) {
      d.setAttribute('aria-current', i === current ? 'true' : 'false');
    });
  }
  if (dotsWrap && slides.length > 1) {
    slides.forEach(function (_, i) {
      var b = document.createElement('button');
      b.className = 'pdp__dot';
      b.type = 'button';
      b.setAttribute('aria-label', 'Image ' + (i + 1));
      b.addEventListener('click', function () { goTo(i); });
      dotsWrap.appendChild(b);
    });
    updateDots();
  }
  if (track) {
    var scrollTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var idx = Math.round(track.scrollLeft / track.clientWidth);
        if (idx !== current && slides[idx]) {
          current = idx;
          thumbs.forEach(function (t, i) {
            if (i === idx) t.setAttribute('aria-current', 'true');
            else t.removeAttribute('aria-current');
          });
          updateDots();
        }
      }, 80);
    }, { passive: true });
  }

  // lightbox
  var lightbox = root.querySelector('[data-lightbox]');
  var lightboxImg = root.querySelector('[data-lightbox-img]');
  if (lightbox && lightboxImg) {
    root.addEventListener('click', function (e) {
      var img = e.target.closest('.pdp__slide img[data-zoom-src]');
      if (!img) return;
      lightboxImg.src = img.dataset.zoomSrc;
      lightboxImg.alt = img.alt || '';
      lightbox.showModal();
    });
    lightbox.addEventListener('click', function () { lightbox.close(); });
  }

  /* ---------- variants ---------- */
  var variantJsonEl = root.querySelector('[data-variant-json]');
  var variants = [];
  try { variants = JSON.parse(variantJsonEl ? variantJsonEl.textContent : '[]'); } catch (e) {}

  var optionGroups = Array.prototype.slice.call(root.querySelectorAll('[data-option]'));
  var priceEl = root.querySelector('[data-price]');
  var compareEl = root.querySelector('[data-compare]');
  var saveEl = root.querySelector('[data-save]');
  var liveEl = root.querySelector('[data-live]');
  var stickyPrice = root.querySelector('[data-sticky-price]');
  var stickyCta = root.querySelector('[data-sticky-cta]');

  // Keyed by the product's real option index, not DOM order: the Case/Pallet
  // option is never rendered, so a plain map() would shift every option left
  // and match colour against the wrong option whenever Format isn't last.
  function selectedOptions() {
    var picked = {};
    var max = -1;
    optionGroups.forEach(function (g) {
      var i = parseInt(g.dataset.index, 10);
      if (isNaN(i)) return;
      var checked = g.querySelector('[aria-checked="true"]');
      picked[i] = checked ? checked.dataset.value : null;
      if (i > max) max = i;
    });
    var out = [];
    for (var i = 0; i <= max; i++) out.push(i in picked ? picked[i] : null);
    return out;
  }

  function findVariant(opts) {
    var matches = variants.filter(function (v) {
      // null = an option with no picker (Format); it can't narrow the match.
      return opts.every(function (val, i) { return val == null || v['option' + (i + 1)] === val; });
    });
    if (!matches.length) return null;
    // The Case/Pallet option has no picker, so a colour selection matches both
    // the case and the pallet variant. Prefer one the page rendered a buy box
    // for — pallet variants are folded into the wholesale card's toggle.
    var rendered = matches.filter(function (v) {
      return root.querySelector('[data-variant-buybox="' + v.id + '"]');
    })[0];
    return rendered || matches[0];
  }

  function applyVariant(variant) {
    if (!variant) return;
    // A locked price is the product's MSRP, not a variant price (wholesale-only
    // products price their variants per case) — leave it alone on variant change.
    var priceLocked = priceEl && priceEl.hasAttribute('data-price-locked');
    if (priceEl && !priceLocked) priceEl.textContent = money(variant.price);
    if (compareEl && !priceLocked) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.hidden = false;
        compareEl.textContent = money(variant.compare_at_price);
        if (saveEl) {
          saveEl.hidden = false;
          saveEl.textContent = 'Save ' + Math.round((1 - variant.price / variant.compare_at_price) * 100) + '%';
        }
      } else {
        compareEl.hidden = true;
        if (saveEl) saveEl.hidden = true;
      }
    }
    // toggle per-variant buy boxes
    root.querySelectorAll('[data-variant-buybox]').forEach(function (box) {
      box.hidden = box.dataset.variantBuybox !== String(variant.id);
    });
    // sticky bar sync
    if (stickyPrice && !stickyPrice.hasAttribute('data-price-locked')) stickyPrice.textContent = money(variant.price);
    if (stickyCta) {
      var visibleBuy = root.querySelector('[data-variant-buybox]:not([hidden]) .buy-btn[href]');
      if (visibleBuy) stickyCta.href = visibleBuy.getAttribute('href');
    }
    // jump gallery to variant media
    if (variant.featured_media) {
      var idx = slides.findIndex(function (s) { return s.dataset.mediaId === String(variant.featured_media.id); });
      if (idx > -1) goTo(idx);
    }
    // URL
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
    } catch (e) {}
    // announce
    if (liveEl) {
      liveEl.textContent = variant.title + ', ' + money(variant.price) + (variant.available ? '' : ', sold out');
    }
  }

  function markUnavailable() {
    optionGroups.forEach(function (g, gi) {
      g.querySelectorAll('.pdp__value').forEach(function (btn) {
        var exists = variants.some(function (v) {
          return v['option' + (gi + 1)] === btn.dataset.value && v.available;
        });
        btn.classList.toggle('pdp__value--off', !exists);
      });
    });
  }

  optionGroups.forEach(function (g) {
    g.addEventListener('click', function (e) {
      var btn = e.target.closest('.pdp__value');
      if (!btn) return;
      g.querySelectorAll('.pdp__value').forEach(function (b) { b.setAttribute('aria-checked', 'false'); });
      btn.setAttribute('aria-checked', 'true');
      var variant = findVariant(selectedOptions());
      applyVariant(variant);
    });
  });
  if (optionGroups.length) markUnavailable();

  /* ---------- accordions ---------- */
  root.querySelectorAll('[data-acc]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      var panel = btn.nextElementSibling;
      if (panel) panel.classList.toggle('open', !open);
    });
  });

  /* ---------- sticky buy bar ---------- */
  var sticky = root.querySelector('[data-sticky]');
  var buybox = root.querySelector('[data-buybox]');
  if (sticky && buybox && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      var below = entries[0].boundingClientRect.bottom < 0;
      sticky.classList.toggle('visible', below);
      sticky.setAttribute('aria-hidden', below ? 'false' : 'true');
    }, { threshold: 0 });
    io.observe(buybox);
  }

  /* ---------- async recommendations ---------- */
  var recs = document.querySelector('[data-recommendations]');
  if (recs) {
    var recsUrl = recs.dataset.url;
    fetch(recsUrl)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-recommendations-grid]');
        var target = recs.querySelector('[data-recommendations-grid]');
        if (fresh && target && fresh.children.length > 0) {
          target.innerHTML = fresh.innerHTML;
        }
      })
      .catch(function () {});
  }

  /* ---------- recently viewed ---------- */
  var rvWrap = document.querySelector('[data-recently-viewed]');
  var KEY = 'eagle-recently-viewed';
  try {
    var entry = {
      handle: root.dataset.productUrl,
      title: document.querySelector('.pdp__title') ? document.querySelector('.pdp__title').textContent.trim() : '',
      img: (root.querySelector('.pdp__slide img') || {}).currentSrc || '',
      price: priceEl ? priceEl.textContent : ''
    };
    var list = JSON.parse(localStorage.getItem(KEY) || '[]').filter(function (p) { return p.handle !== entry.handle; });
    var toRender = list.slice(0, 4);
    list.unshift(entry);
    localStorage.setItem(KEY, JSON.stringify(list.slice(0, 8)));

    if (rvWrap && toRender.length > 0) {
      var grid = rvWrap.querySelector('[data-rv-grid]');
      if (grid) {
        toRender.forEach(function (p) {
          var li = document.createElement('li');
          li.className = 'ec-card';
          var mediaOuter = document.createElement('div');
          mediaOuter.className = 'ec-card__media-wrap';
          var mediaWrap = document.createElement('div');
          mediaWrap.className = 'ec-card__media';
          if (p.img) {
            var img = document.createElement('img');
            img.src = p.img;
            img.alt = p.title;
            img.loading = 'lazy';
            mediaWrap.appendChild(img);
          }
          mediaOuter.appendChild(mediaWrap);
          var title = document.createElement('h3');
          title.className = 'ec-card__title';
          var a = document.createElement('a');
          a.href = p.handle;
          a.className = 'ec-card__stretch';
          a.textContent = p.title;
          title.appendChild(a);
          var foot = document.createElement('div');
          foot.className = 'ec-card__foot';
          var price = document.createElement('div');
          price.className = 'ec-card__price';
          price.textContent = p.price;
          foot.appendChild(price);
          li.appendChild(mediaOuter);
          li.appendChild(title);
          li.appendChild(foot);
          grid.appendChild(li);
        });
        rvWrap.hidden = false;
      }
    }
  } catch (e) {}
})();
